export const REJECTED_DISPLAY_TEXT = "Declined";

export const REVERTED_OVERRIDE_REASON_ID = "5e69ab0e-1bfb-4a81-bead-74b6de0caa1e";
